module.exports = __webpack_public_path__ + "title_icon.2a9659a4.png";